import React, { useMemo } from 'react';
import { Polygon } from 'react-leaflet';
import { cellToBoundary } from 'h3-js';
import type { GridCell } from '../hooks/useClusters';

interface UnclaimedHaloOverlayProps {
    grid: GridCell[];
}

// lighter style so halo doesn't compete with local grid overlay
const HALO_FILL = 'rgba(148, 163, 184, 0.2)';
const HALO_STROKE = 'rgba(100, 116, 139, 0.4)';

const UnclaimedHaloOverlay: React.FC<UnclaimedHaloOverlayProps> = ({ grid }) => {
    const polygons = useMemo(() => {
        return grid.map(({ cell }) => {
            const boundary = cellToBoundary(cell);
            const positions: [number, number][] = boundary.map(([lat, lng]) => [lat, lng]);
            return { key: cell, positions };
        });
    }, [grid]);

    return (
        <>
            {polygons.map(({ key, positions }) => (
                <Polygon
                    key={key}
                    positions={positions}
                    pathOptions={{
                        color: HALO_STROKE,
                        fillColor: HALO_FILL,
                        fillOpacity: 0.35,
                        weight: 1,
                        opacity: 0.6
                    }}
                />
            ))}
        </>
    );
};

export default UnclaimedHaloOverlay;
